<template>
  <v-layout>
    <v-flex>
      <v-layout align-center>
        <h1 class="headline">Languages</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="createItem"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Language</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="languages.edges"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
        >
          <template v-slot:item.forContent="{ item }">
            <v-checkbox
              v-model="item.node.forContent"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.isDefault="{ item }">
            <v-checkbox
              v-model="item.node.isDefault"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="languageEditorDialog" persistent width="700">
        <v-card>
          <language-editor
            :language="selectedLanguage"
            :doSaveLanguage="doSaveLanguage"
            :languageEditorDialog="languageEditorDialog"
            @saved="onSaved($event)"
            @onResetSave="onResetSave"
          ></language-editor>
          <v-card-actions class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
            <v-btn color="primary" @click="onSaveLanguage">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_LANGUAGES_SEARCH_QUERY,
  LANGUAGE_DELETE_MUTATION,
} from "../../../../constants/graphql";
import LanguageEditor from "./LanguageEditor";
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";

export default {
  name: "LanguagesList",

  components: {
    DefaultListActions,
    LanguageEditor,
  },

  data() {
    return {
      pagingOptions,
      search: "",
      selectedLanguage: {},
      doSaveLanguage: false,
      languages: {},
      languageEditorDialog: false,
      headers: [
        {
          text: "Name",
          value: "node.name",
          name: "name",
        },
        {
          text: "Code",
          value: "node.code",
          name: "code",
        },
        {
          text: "For Content",
          value: "forContent",
          name: "forContent",
        },
        {
          text: "Is Default",
          value: "isDefault",
          name: "isDefault",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    createItem() {
      this.selectedLanguage = {
        name: "",
        code: "",
        forContent: false,
        isDefault: false,
      };
      this.languageEditorDialog = true;
    },
    editItem(item) {
      this.selectedLanguage = item.node;
      this.languageEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: LANGUAGE_DELETE_MUTATION,
          variables: {
            languageId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Language removed." });

      if (this.$apollo.queries.languages != null) {
        this.$apollo.queries.languages.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.languages != null) {
        this.$apollo.queries.languages.refetch();
      }
      this.onResetSave();
      this.languageEditorDialog = false;
      this.selectedLanguage = {};
      let msg = context == "edit" ? "Language updated." : "Language created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSaveLanguage = false;
    },
    closeDialog() {
      this.languageEditorDialog = false;
      this.selectedLanguage = {};
    },
    onSaveLanguage() {
      this.doSaveLanguage = true;
    },
  },

  apollo: {
    languages: {
      query: ALL_LANGUAGES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {},
    },
  },
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/gt/admin/languages/LanguagesList.vue